import { HTMLTagTypes } from '../../../../../domain/html';

export const isAnchorTagNode = (node: Node): node is HTMLAnchorElement =>
  node.nodeName === HTMLTagTypes.Anchor;
